const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/user/$userId/statistics.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/user/$userId/statistics")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Usage Statistics",
      description: "Page title for the user usage statistics page"
    })
  }
});